import _ from '@/apps/common/lodash';
import { BaseItemStateModule } from '@/definitions/base.item.state.module';
import { BaseItemsStateModule } from '@/definitions/base.items.state.module';
import { components, operations } from '@/definitions/openapi';
import { configureDynamicStoreModuleFactory } from '@/store/common';
import { schema } from '@/store/sessions/blocklist-records/filter.schema';
import { EmptyFilter, EmptyItem } from '@/store/sessions/blocklist-records/items';
import { Module, RegisterOptions } from 'vuex-class-modules';
import store from '../../index';

export type IBlockListRecord = components['schemas']['DeviceBlacklistRecord'];
export type IBlockListRecordsFilter = operations['device_blacklist_records_list']['parameters']['query'];

@Module({ generateMutationSetters: true })
export class BlocklistRecordsModule extends BaseItemsStateModule<IBlockListRecord, IBlockListRecordsFilter> {
  name = 'device-blacklist-records';
  routeName = 'blocklistRecords';

  constructor(options: RegisterOptions) {
    super(options);

    this.filter.empty = _.cloneDeep(EmptyFilter);
    this.filter.current = _.cloneDeep(EmptyFilter);
    this.filter.schema = schema;
    this.item.empty = _.cloneDeep(EmptyItem);
    // this.setCustomRequestHandler(mockBlocklistRecordsService.requestHandler);
  }

  async dispatchImplementation(action: string, payload: any): Promise<any> {
    return store.dispatch(action, payload);
  }
}

@Module({ generateMutationSetters: true })
export class BlocklistRecordModule extends BaseItemStateModule<IBlockListRecord> {
  name = 'device-blacklist-records';
  routeName = 'blocklistRecord';

  constructor(options: RegisterOptions) {
    super(options);
    this.emptyItem = _.cloneDeep(EmptyItem);
    this.setEmptyItemsState();
    // this.setCustomRequestHandler(mockBlocklistRecordsService.requestHandler);
  }

  async dispatchImplementation(action: string, payload: any): Promise<any> {
    return store.dispatch(action, payload);
  }
}

export const createBlocklistRecordModule = configureDynamicStoreModuleFactory('blocklist-record', (store, name) => {
  return new BlocklistRecordModule({ store, name });
});
